<template>
  <div class="mypage-contact-us-pane">
    <h3
      class="mypage-contact-us-pane__title"
      v-html="$tc('MypagePage.MypageContactUsPage.titleFAQ')"
    />
    <a class="mypage-contact-us-pane__link" :href="sfAboutSFgoUrl" target="_blank">{{
      sfAboutSFgoUrl
    }}</a>
    <p
      class="mypage-contact-us-pane__message"
      v-html="$tc('MypagePage.MypageContactUsPage.message')"
    />

    <h3
      class="mypage-contact-us-pane__title"
      v-html="$tc('MypagePage.MypageContactUsPage.titleEmail')"
    />
    <div class="mypage-contact-us-pane__button">
      <atom-link-button
        :linkText="$tc('MypagePage.MypageContactUsPage.toContactForm')"
        :url="inquiryFormUrl"
        :isDisabled="true"
        colorType="secondary"
      />
    </div>
    <p class="mypage-contact-us-pane__attention-inquiry">
      {{ $tc('MypagePage.MypageContactUsPage.attentionInquiry') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomLinkButton from '@/components/atoms/AtomLinkButton.vue'
import StoreUtil from '@/store/StoreUtil'
import DeviceInfo from '@/util/DeviceInfo'
import Const from '@/util/Const'

/**
 * お問い合わせページ ペイン
 */
export default defineComponent({
  name: 'MypageContactUsPane',
  components: {
    AtomLinkButton,
  },
  setup() {
    const mypagePageStore = StoreUtil.useStore('MypagePageStore')
    const { user } = mypagePageStore

    const userLang = user.value.lang || DeviceInfo.getLanguage()

    // SUPER FORMULA公式サイト ABOUT SFgoページへのリンク
    const sfAboutSFgoUrl =
      userLang === 'ja' ? Const.EXTERNAL_LINKS.ABOUT_SFGO.JA : Const.EXTERNAL_LINKS.ABOUT_SFGO.EN

    // お問い合わせフォームへのリンク
    const inquiryFormUrl = Const.EXTERNAL_LINKS.GOOGLE_INQUIRY_FORM

    return {
      sfAboutSFgoUrl,
      inquiryFormUrl,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-contact-us-pane {
  width: 100%;
  max-width: 840px;
  padding: 40px 16px 80px;
  margin: 0 auto;
  text-align: center;
  color: $gray75;
  background: $gray1;
  font-feature-settings: 'palt' on;
  letter-spacing: 0.04em;
  font-family: $fontSignup;

  &__title {
    @include fontSetTextMedium(17);

    line-height: 1.41;
    font-weight: 500;

    &:nth-child(n + 2) {
      margin-top: 36px;
    }
  }

  &__link {
    @include fontSetTextMedium(13);

    display: block;
    width: 100%;
    margin-top: 24px;
    text-decoration: underline;
    text-underline-offset: 5px;
    color: $gray75;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  &__message {
    @include fontSetTextMedium(13);

    margin-top: 24px;
    color: $gray75;
  }

  &__button {
    margin-top: 24px;
  }

  &__attention-inquiry {
    margin-top: 16px;
  }
}
</style>
